<template>
  <div class="vx-row" id="rm-order-details-view" >
    <div class="vx-col w-full">
      <vx-card  v-if="dataLoaded" :title="orderDetails.purchase_order_code">
        <template slot="actions">
          <div class="flex">
            <div class="flex">
<!--              <vs-button v-can="'create-edit-raw-material-orders'" @click="onClickProductOrderUpdate('details')" color="warning" type="border" >Update Order Details</vs-button>-->
<!--              <vs-button v-can="'view-raw-material-orders'" @click="onClickPoPdf()" class="ml-2" color="dark" type="border" >Purchase Order PDF</vs-button>-->
<!--              <vs-button  @click="onClickBack" class="ml-2" color="primary" type="filled">Back to orders</vs-button>-->

              <vs-dropdown>

                <a class="flex items-center" href="#">
                  <i class="material-icons"> menu </i>
                </a>

                <vs-dropdown-menu class="w-64">

                  <vs-dropdown-item
                    v-can="'create-edit-raw-material-orders'"
                    @click="onClickProductOrderUpdate('details')">
                    Update Order Details & Additional Cost
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-can="'create-edit-raw-material-orders'"
                    @click="onClickProductOrderUpdate('items')">
                    Update Item Quantity & Price
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-can="'view-raw-material-orders'"
                    @click="onClickPoPdf()">
                    Purchase Order PDF
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    v-can="'view-raw-material-orders'"
                    @click="onClickPoPdfEmailLog()">
                    Purchase Order PDF Email Log
                  </vs-dropdown-item>
                  <vs-dropdown-item
                    @click="onClickBack">
                    Back to orders
                  </vs-dropdown-item>

                </vs-dropdown-menu>
              </vs-dropdown>

            </div>
          </div>
        </template>

        <div class="vx-row md:mb-3 mt-8">
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Supplier</h5>
                    {{orderDetails.supplier.company_name}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="UserCheckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Ordered By</h5>
                    {{orderDetails.staff}}
                  </span>
              </vs-col>
            </vs-row>
          </div>

          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Order Date</h5>
                    {{__dateTimeFormatter(orderDetails.created_at)}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Notes</h5>
                    {{orderDetails.note || 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="InfoIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Sage Order Id</h5>
                    <span class="text-danger">{{orderDetails.sage_order_number || 'N/A'}}</span>
                  </span>
              </vs-col>
            </vs-row>
          </div>
<!--          <div class="vx-col md:w-1/4 w-full">-->
<!--            <vs-row vs-type="flex">-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">-->
<!--                <feather-icon icon="RefreshCwIcon" class="text-success cursor-pointer"/>-->
<!--              </vs-col>-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">-->
<!--                  <span class="text-md break-all">-->
<!--                    <h5 class="mb-2">Order Status</h5>-->
<!--                      <vs-chip style="border-radius: 0" class="text-center"-->
<!--                               transparent-->
<!--                               :color="orderDetails.is_item_status_handled_individually ? 'dark' : ProductOrderStatusColorFactory()">-->
<!--                        {{ orderDetails.is_item_status_handled_individually ? 'PO Ungrouped' : orderDetails.status.name }}-->
<!--                      </vs-chip>-->
<!--                  </span>-->
<!--              </vs-col>-->
<!--            </vs-row>-->
<!--          </div>-->
        </div>
        <div class="vx-row md:mb-3 mt-16">
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="MapPinIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Invoice Address</h5>
                    {{orderDetails.line1}} <br v-if="orderDetails.line1">
                    {{orderDetails.line2}} <br v-if="orderDetails.line2">
                    {{orderDetails.line3}} <br v-if="orderDetails.line3">
                    {{orderDetails.town_state}} <br>
                    {{orderDetails.post_code}} <br>
                    {{orderDetails.country}} <br>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="MapPinIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Delivery Address</h5>
                    {{orderDetails.delivery_address.line1}} <br v-if="orderDetails.delivery_address.line1">
                    {{orderDetails.delivery_address.line2}} <br v-if="orderDetails.delivery_address.line2">
                    {{orderDetails.delivery_address.line3}} <br v-if="orderDetails.delivery_address.line3">
                    {{orderDetails.delivery_address.town_state}} <br>
                    {{orderDetails.delivery_address.post_code}} <br>
                    {{orderDetails.delivery_address.country}} <br>
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CalendarIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Required By Date</h5>
                    {{orderDetails.required_by || 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="TruckIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Delivery Instructions</h5>
                    {{orderDetails.delivery_instruction || 'N/A'}}
                  </span>
              </vs-col>
            </vs-row>
          </div>


          <!-- <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="CreditCardIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md break-all">
                    <h5 class="mb-2">Payment Status</h5>
                    <v-select :clearable="false"
                              :options="payment_status"
                              v-model="orderDetails.payment_status"
                              @input="openPaymentStatusChangeConfirm()"
                              :reduce = "option => option.value"
                              label="name"
                              :dir="$vs.rtl ? 'rtl' : 'ltr'"
                    />
                  </span>
              </vs-col>
            </vs-row>
          </div> -->
          <div class="vx-col md:w-1/5 w-full">
            <vs-row vs-type="flex">
              <vs-col
                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">
                <feather-icon icon="FileIcon" class="text-success cursor-pointer"/>
              </vs-col>
              <vs-col
                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">
                  <span class="text-md">
                    <h5 class="mb-2">Order Documents</h5>
<!--                    <vs-button @click="openFileUploadPopUp" size="small" color="success" type="filled" icon-pack="feather"-->
<!--                               icon="icon-plus" v-if="invoiceDocuments.length === 0">Add Documents</vs-button>-->
                    <vs-button @click="openInvoiceDocument" size="small" color="success" type="filled" icon-pack="feather"
                               icon="icon-eye">View Documents</vs-button>
                  </span>
              </vs-col>
            </vs-row>
          </div>

<!--          <div v-can="'create-edit-raw-material-orders'" class="vx-col md:w-1/4 w-full" v-if="orderDetails.raw_material_items.length > 1">-->
<!--            <vs-row vs-type="flex">-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="center" vs-align="start" vs-w="2">-->
<!--                <feather-icon icon="SettingsIcon" class="text-success cursor-pointer"/>-->
<!--              </vs-col>-->
<!--              <vs-col-->
<!--                vs-type="flex" vs-justify="start" vs-align="start" vs-w="10">-->
<!--                  <span class="text-md break-word">-->
<!--                    <h5 class="mb-2">Do you want to handle each item on this order independently? <br>-->
<!--                    <span class="text-danger text-sm">( If not this <span class="font-bold">PO</span> will be process as a multi-product batch )</span></h5>-->
<!--                    <vs-switch :disabled="orderDetails.raw_material_items.length === 1" v-on:input="onChangeOrderStatusHandle()" v-model="orderDetails.is_item_status_handled_individually" />-->
<!--                  </span>-->
<!--              </vs-col>-->
<!--            </vs-row>-->
<!--          </div>-->


        </div>

        <div v-can="'create-edit-raw-material-orders'" class="vx-row" v-if="orderDetails.raw_material_items.length === 1">
          <div class="vx-col w-full">
            <div class="flex float-right">
              <vs-dropdown>

                <a class="flex items-center" href="#">
                  Order Status
                  <i class="material-icons"> expand_more </i>
                </a>

                <vs-dropdown-menu class="w-64">

                  <vs-dropdown-item
                    v-for="status in raw_material_order_statuses"
                    v-bind:key="status.slug"
                    v-if="(status.before_status.includes(orderDetails.status.name) || orderDetails.raw_material_items.map((n) => n.item_status).includes(status.item_status)) && checkIfPartialAndOneItem(status.is_partial_status)"
                    @click="onClickStatusChangeConfirm(orderDetails.id, status.slug)">
                    {{  statusNameFactory(status.name) }}
                  </vs-dropdown-item>

                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </div>
        </div>
      </vx-card>
      <vx-card v-if="dataLoaded" class="mt-8 mb-3" title="Order Items">
<!--        <template slot="actions">-->

<!--          <vs-button v-can="'create-edit-raw-material-orders'"-->
<!--                     @click="onClickProductOrderUpdate('items')"-->
<!--                     color="warning" type="border" >Update Item Quantity</vs-button>-->
<!--        </template>-->

        <div class="vx-row my-8">
          <div class="vx-col w-full">
            <product-order-table v-bind:is_item_status_handled_individually="orderDetails.is_item_status_handled_individually"
                                 v-bind:id="orderDetails.id"
                                 v-bind:items="orderDetails.raw_material_items"
                                 v-on:statusChangeNotify="getRmOrderDetails()"
            />
          </div>
        </div>
      </vx-card>
      <vx-card class="mb-3" title="Additional cost" v-if="dataLoaded">
        <div class="vx-row mb-4">
          <div class="w-full vx-col md:w-2/3 md:mb-0">
            <vs-table :data="orderDetails.additional_cost">

              <template slot="thead">
                <vs-th width="30%">Details</vs-th>
                <vs-th width="30%">Value (GBP)</vs-th>
              </template>

                  <template slot-scope="{data}">
                    <vs-tr :key="index_item" v-for="(tr_item, index_item) in data">

                      <vs-td :data="tr_item.name">
                        {{ tr_item.name }}
                      </vs-td>

                      <vs-td :data="tr_item.amount">
                        {{ tr_item.amount }}
                      </vs-td>

                    </vs-tr>
                  </template>
                </vs-table>
              </div>
            </div>
      </vx-card>
    </div>
    <update-rm-order-pop-up ref="updateRmOrderPopUp"/>
    <PartialItemsStatusChangePopUp ref="partialItemsStatusChangePopUp"/>
    <rm-order-purchase-order-pdf-pop-up ref="rmOrderPurchaseOrderPdfPopUp"/>
    <add-supplier-invoice-file-pop-up ref="AddSupplierInvoiceFilePopUp"/>
    <view-supplier-invoice-list-popup ref="ViewSupplierInvoiceListPopup"/>
    <rm-order-invoice-email-log-pop-up ref="rmOrderInvoiceEmailLogPopUp"/>
  </div>
</template>

<script>
  import ProductOrderTable from './ProductOrderTable'
  import { RepositoryFactory } from '@/repository/RepositoryFactory'
  const InventoryRepository = RepositoryFactory.get('inventory')
  import SuccessMessage from '@/mixins/SuccessMessage'
  import ErrorMessages from '@/mixins/ErrorMessages'
  import PartialItemsStatusChangePopUp from "@/components/popups/inventory/rm-orders/PartialItemsStatusChangePopUp";
  import RmOrderPurchaseOrderPdfPopUp
    from "@/components/popups/inventory/rm-orders/RmOrderPurchaseOrderPdfPopUp";
  import AddSupplierInvoiceFilePopUp from "@/components/popups/raw-materials/AddSupplierInvoiceFilePopUp";
  import UpdateRmOrderPopUp from '@/components/popups/inventory/rm-orders/UpdateRmOrderPopUp'
  import {raw_material_order_statuses} from '@/constants/statuses'
  import vSelect from "vue-select";
  import ViewSupplierInvoiceListPopup from "@/components/popups/raw-materials/ViewSupplierInvoiceListPopup";
  import RmOrderInvoiceEmailLogPopUp from "@/components/popups/inventory/rm-orders/RmOrderInvoiceEmailLogPopUp";

  export default {
    name: "RmOrderDetailsView",
    components: {
      ViewSupplierInvoiceListPopup,
      ProductOrderTable,
      PartialItemsStatusChangePopUp,
      UpdateRmOrderPopUp,
      RmOrderPurchaseOrderPdfPopUp,
      'v-select': vSelect,
      AddSupplierInvoiceFilePopUp,
      RmOrderInvoiceEmailLogPopUp
      // RMOrdersList
    },
    data: function() {
      return {
        orderDetails: {
          additional_cost: []
        },
        id: '',
        dataLoaded: false,
        is_po_handle_as_independently: false,
        raw_material_order_statuses: raw_material_order_statuses,
        payment_status:[
          {name: 'Pre Invoice', value: 'pre-invoice'},
          {name: 'Paid', value: 'paid'},
          {name: 'GRNI', value: 'grni'}
        ],
        invoiceDocuments:{}
      }
    },
    mixins : [ SuccessMessage, ErrorMessages],
    async mounted() {
      this.id = this.$route.params.id
      await this.getRmOrderDetails()
      await this.getSupplierInvoiceDocuments()
    },
    methods: {
      onClickBack() {
        // this.$emit('back')
        this.$router.push({path: `/pages/raw-materials?step=1`})
      },
      async refreshData () {
        this.getProductOrderList()
      },
      async backOnDetailsView() {
        this.is_on_details_view = false
        this.getProductOrderList()
      },
      async onClickStatusChangeConfirm(id, status) {
        if (['part_accepted', 'part_dispatched', 'part_received', 'part_return'].includes(status)) {
          await this.$refs.partialItemsStatusChangePopUp.openPopup(id, status, this.orderDetails.raw_material_items)
        } else {
          this.$vs.dialog({
            type: 'confirm',
            color: status === 'goods_not_received' ? 'warning' : 'primary',
            title: 'Confirm',
            text: status === 'goods_not_received' ? 'Are you sure to change all items to goods not received?' : 'Are you sure you want to make this change?',
            accept: this.onChangeSampleOrderStatus,
            parameters: [id, status]
          })
        }
      },
      openPaymentStatusChangeConfirm(){
        this.$vs.dialog({
          type: 'confirm',
          color: 'danger',
          title: 'Confirm',
          text: 'Are you sure you want to change payment status?',
          accept: this.onClickChangePaymentStatus,
        })
      },
      async onClickChangePaymentStatus(){
        await this.$vs.loading()
        try {
          const status = this.orderDetails.payment_status
          await InventoryRepository.rawMaterialOrderChangeStatus(this.orderDetails.id, status)
          await this.getRmOrderDetails()
          this.showSuccessMessage('Status change successfully!')
        }catch (error){
          this.convertAndNotifyError(error)
        }
        this.$vs.loading.close()
      },
      async onChangeSampleOrderStatus(params){
        await this.$vs.loading({
          container: '#rm-order-details-view',
          scale: 0.45
        })
        try {
          await InventoryRepository.rmOrdersStatusChange(params[0], params[1])
          this.showSuccessMessage('Status change successfully!')
          await this.getRmOrderDetails()
        }catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-details-view > .con-vs-loading')
      },
      async getRmOrderDetails() {
        await this.$vs.loading({
          container: '#rm-order-details-view',
          scale: 0.45
        })
        try {
          const {data} = (await InventoryRepository.getRmOrderDetails(this.id)).data
          this.orderDetails = data
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-details-view > .con-vs-loading')
        this.dataLoaded= true
      },
      async getSupplierInvoiceDocuments(){
        const {data} = await InventoryRepository.getRawMaterialOrderDocument(this.id)
        this.invoiceDocuments = data.data.filter((invoice) => invoice.type === 'invoice' )
      },
      async onClickProductOrderUpdate (update_type) {
        await this.$refs.updateRmOrderPopUp.openPopup(this.id, update_type)
      },
      async onClickPoPdf() {
        let routeData = this.$router.resolve({name:'rm-orders-print-view', params:{id:this.id}})
        window.open(routeData.href,'_blank');
      },
      async onClickPoPdfEmailLog() {
        await this.$refs.rmOrderInvoiceEmailLogPopUp.openPopUp(this.id)
      },
      async openFileUploadPopUp(){
        await this.$refs.AddSupplierInvoiceFilePopUp.openPopup(this.id)
      },
      async openInvoiceDocument(){
        await this.$refs.ViewSupplierInvoiceListPopup.openPopup(this.id)
      },
      async getProductOrderList() {
        await this.getRmOrderDetails()
      },
      /**
       * @return {string}
       */
      ProductOrderStatusColorFactory() {
        let selected_status = this.raw_material_order_statuses.find((n) => n.name === this.orderDetails.status.name)
        return selected_status ?  selected_status.color : 'dark'
      },
      async onChangeOrderStatusHandle () {
        await this.$vs.loading({
          container: '#rm-order-details-view',
          scale: 0.45
        })
        try {
          await InventoryRepository.changeRmOrderHandleType(this.id)
        } catch (e) {
          this.convertAndNotifyError(e)
        }
        this.$vs.loading.close('#rm-order-details-view > .con-vs-loading')
      },
      checkRmItemsAreEqual() {
        return this.orderDetails.raw_material_items.map((n) => n.item_status).every( (val, i, arr) => val === arr[0] )
      },
      checkIfPartialAndOneItem(is_partial_status) {
        return !(is_partial_status && this.orderDetails.raw_material_items.length === 1)
      },
      statusNameFactory(status) {
        if(status === 'All Received' ) {
          return 'Batch received (all/partial)'
        }
        return status
      },
    }
  }
</script>

<style scoped>
  /* .user-edit-popup  >>> .vs-popup  {
    min-height: 50% !important;
    min-width: 50% !important;
  }

  @media (min-width: 768px) and (max-width: 1319px) {
    .user-edit-popup  >>> .vs-popup {
      min-height: 50% !important;
      min-width: 65% !important;
    }
  } */

</style>
